import { useEffect, useState } from 'react';
import publicApi from '../services/publicApi';

export default function useTestMode() {
    const [testMode, setTestMode] = useState(false);

    useEffect(() => {
        publicApi.siteConfig
            .get()
            .then((data) => setTestMode(Boolean(data?.test_mode)))
            .catch(() => setTestMode(false));
    }, []);

    useEffect(() => {
        document.body.classList.toggle('test-mode', testMode);
        return () => document.body.classList.remove('test-mode');
    }, [testMode]);

    return testMode;
}
